var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTrophyFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2503 0.749837H9.50033V0.166504H2.50033V0.749837H0.750326C0.400326 0.749837 0.166992 0.983171 0.166992 1.33317V2.73317C0.166992 4.07484 1.15866 5.18317 2.50033 5.35817V5.4165C2.50033 7.10817 3.66699 8.50817 5.24199 8.85817L4.83366 10.0832H3.49199C3.25866 10.0832 3.02533 10.2582 2.96699 10.4915L2.50033 11.8332H9.50033L9.03366 10.4915C8.97532 10.2582 8.74199 10.0832 8.50866 10.0832H7.16699L6.75866 8.85817C8.33366 8.50817 9.50033 7.10817 9.50033 5.4165V5.35817C10.842 5.18317 11.8337 4.07484 11.8337 2.73317V1.33317C11.8337 0.983171 11.6003 0.749837 11.2503 0.749837ZM2.28829 3.87862C1.70496 3.71545 1.22769 3.17155 1.22769 2.51887V1.75741H2.28829V3.87862ZM9.71232 3.87862C10.2957 3.76984 10.7729 3.17155 10.7729 2.51887V1.75741H9.71232V3.87862Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTrophyFilled);
export default __webpack_public_path__ + "static/media/icon-trophy-filled.e6a28179ffe46f3499e7f724d8d3d816.svg";
export { ForwardRef as ReactComponent };